var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeTreino2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2840)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3276 5.1023C22.2205 4.79989 21.9878 4.45137 21.7052 4.17109L18.7646 1.25206C18.3619 0.851918 17.8447 0.571632 17.5104 0.571632C17.3867 0.571632 17.3349 0.608512 17.3072 0.638016C17.0819 0.864826 17.3017 1.62455 17.8521 2.17221L20.7909 5.09123C21.284 5.57989 22.0986 5.85649 22.3147 5.63705C22.4514 5.5006 22.3701 5.21847 22.3276 5.1023Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.661271 17.5676C0.661271 17.9383 0.923558 18.4564 1.29667 18.8271L4.23355 21.7461C4.72672 22.2347 5.54314 22.5113 5.75925 22.2938C5.96058 22.0909 5.726 21.3994 5.14786 20.8278L2.21098 17.9088C1.80647 17.5086 1.29113 17.2283 0.954959 17.2283C0.833051 17.2283 0.781332 17.2652 0.751779 17.2947C0.68713 17.3629 0.659424 17.4496 0.659424 17.5695L0.661271 17.5676Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.22217 14.8017L8.44494 16.0205L15.9903 8.42885L14.7694 7.20998L7.22217 14.8017Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5481 7.86828L18.9844 10.2857C20.1924 11.4843 21.8566 11.8992 22.5991 11.1506C23.3768 10.3669 22.9796 8.74786 21.7365 7.51423L15.4176 1.23916C14.2096 0.0405679 12.5473 -0.372484 11.8029 0.374329C11.0253 1.15618 11.4242 2.77519 12.6655 4.00882L13.9196 5.25351L13.9252 5.24798L16.5499 7.86828H16.5481Z",
    fill: "#ff66c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22729 13.9294L5.23283 13.9239L4.01375 12.7124C3.22135 11.9269 2.25901 11.4585 1.43706 11.4585C1.00299 11.4585 0.653888 11.5894 0.395295 11.8476C-0.380484 12.6313 0.0184879 14.2503 1.25973 15.4839L7.57864 21.759C8.78848 22.9576 10.4527 23.3725 11.1934 22.6238C11.9747 21.842 11.5757 20.223 10.3345 18.9893L9.1616 17.8258L9.14682 17.8405L5.22729 13.9294Z",
    fill: "#ff66c4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2840"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#ff66c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeTreino2);
export default __webpack_public_path__ + "static/media/IconeTreino2.23bc805dbf2ea0f5769abafebb1d7fde.svg";
export { ForwardRef as ReactComponent };